import axios from "axios";

export default class Reservation {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  static send(data: any): any {
    return axios.post("https://api.ezro.link/send", data);
  }
}
